export default "__VITE_ASSET__DZOF9BRC__"